// Keycloak rotates refresh tokens and allows no reuse, so two concurrent refreshes
// with the same token end the session. Every renewal path must share one request.

// Calls `run` at most once at a time: callers arriving while a call is pending get
// the same promise (their own arguments are ignored). The slot clears when it settles.
export function createSingleFlight(run) {
  let inflight = null;
  return function singleFlight(...args) {
    if (inflight) return inflight;
    let pending;
    try {
      pending = Promise.resolve(run.apply(this, args));
    } catch (error) {
      pending = Promise.reject(error);
    }
    const shared = pending.finally(() => { if (inflight === shared) inflight = null; });
    inflight = shared;
    return shared;
  };
}

// Subclass of an oidc-client-ts UserManager whose signinSilent is single-flight.
// oidc-client-ts's own SilentRenewService calls `userManager.signinSilent()`, so
// automatic renewal shares the in-flight request with every explicit caller.
export function withSingleFlightSilentSignIn(BaseUserManager) {
  return class SingleFlightUserManager extends BaseUserManager {
    signinSilent(args) {
      if (!this.singleFlightSilentSignIn) {
        this.singleFlightSilentSignIn = createSingleFlight((callArgs) => super.signinSilent(callArgs));
      }
      return this.singleFlightSilentSignIn(args);
    }
  };
}
